module.exports = __webpack_public_path__ + "static/media/notes-medical.7ecb257a.svg";